import { ff, flags } from 'functions/roleBasedAccessUtils'
import { AdminContext } from 'context/AdminContext'
import { useContext } from 'react';
import { useSelector } from "react-redux"
import { useSidebar } from "components/ui/sidebar";
import { motion } from "framer-motion";
import { ArrowPathRoundedSquareIcon } from "@heroicons/react/20/solid";

export default function SidebarOrganizationDetails({ isTouchDevice = false }) {

    const { open, animate } = useSidebar();

    const userType = useSelector((state) => state.user.type)
    const adminToolsVisible = useSelector((state) => state.user.adminToolsVisible)
    const organizationName = useSelector((state) => state.user.organizationName)
    const organizationLogo = useSelector((state) => state.user.organizationLogo)

    const canAccessSidebarSalesTools = ff(flags.canAccessSidebarSalesTools, { userType: userType, adminToolsVisible: adminToolsVisible })

    const { ShowOrganizationDirectoryModal } = useContext(AdminContext)

    if (isTouchDevice === true) {
        return (
            <div className="my-2 flex flex-col items-center">
                <div className="flex-shrink-0 w-12 h-12">
                    <img 
                        src={organizationLogo} 
                        alt={`${organizationName} Logo`} 
                        className="w-full h-full rounded-full object-cover" 
                    />
                </div>
            </div>
        )
    }

    if (isTouchDevice === false) {
        return (
            <div className="my-2 flex items-center gap-x-2 relative">
                <div className="flex-shrink-0 w-7 h-7">
                    <img 
                        src={organizationLogo} 
                        alt={`${organizationName} Logo`} 
                        className="w-full h-full rounded-full object-cover" 
                    />
                </div>

                <motion.span
                    initial={{
                        display: animate ? (open ? "inline-block" : "none") : "inline-block",
                        opacity: animate ? (open ? 1 : 0) : 1,
                    }}
                    animate={{
                        display: animate ? (open ? "inline-block" : "none") : "inline-block",
                        opacity: animate ? (open ? 1 : 0) : 1,
                    }}
                    className={`
                        text-neutral-200 group-hover/sidebar:translate-x-1 transition duration-150 whitespace-pre inline-block !p-0 !m-0
                        ${organizationName.length > 20 ? 'text-xs' : 'text-sm'}
                    `}
                >
                    {organizationName}
                </motion.span>

                {canAccessSidebarSalesTools && open && (
                    <button 
                        className="absolute right-0 top-0 h-full flex items-center justify-center bg-zinc-700 px-1.5 rounded-lg border border-zinc-600"
                        onClick={ShowOrganizationDirectoryModal}
                    >
                        <ArrowPathRoundedSquareIcon className="h-5 w-5 text-neutral-200" />
                    </button>
                )}
            </div>
        )
    }
}